var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 305.46 94.26",
    style: {
      enableBackground: "new 0 0 305.46 94.26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:#595857;}\n\t.st18{fill:#717071;}\n\t.st19{fill:none;stroke:#717071;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5867,
    y1: -1.8954,
    x2: 47.7467,
    y2: 50.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.36,7.47h12.16l4.38,23.2l6.41-23.2h12.12l6.43,23.17l4.38-23.17h12.1l-9.14,41.45H37.65l-7.27-26.1 l-7.24,26.1H10.58L1.36,7.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.7368,
    y1: 19.1405,
    x2: 87.3624,
    y2: 53.1329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.98,28.62l-11-1.16c0.41-1.92,1.01-3.44,1.8-4.54c0.78-1.1,1.91-2.06,3.38-2.87 c1.06-0.58,2.51-1.04,4.35-1.36c1.85-0.32,3.85-0.48,5.99-0.48c3.45,0,6.22,0.19,8.31,0.58c2.09,0.39,3.84,1.19,5.23,2.42 c0.98,0.85,1.75,2.05,2.32,3.6c0.57,1.55,0.85,3.04,0.85,4.45v13.26c0,1.41,0.09,2.52,0.27,3.32c0.18,0.8,0.57,1.82,1.17,3.07 h-10.8c-0.43-0.77-0.72-1.36-0.85-1.77c-0.13-0.4-0.26-1.04-0.4-1.91c-1.51,1.45-3.01,2.49-4.5,3.11c-2.04,0.83-4.4,1.24-7.1,1.24 c-3.58,0-6.3-0.83-8.16-2.49c-1.86-1.66-2.78-3.7-2.78-6.14c0-2.28,0.67-4.16,2.01-5.63c1.34-1.47,3.81-2.56,7.41-3.28 c4.32-0.87,7.12-1.47,8.4-1.82c1.28-0.35,2.64-0.81,4.07-1.37c0-1.41-0.29-2.4-0.88-2.97c-0.58-0.57-1.61-0.85-3.08-0.85 c-1.89,0-3.3,0.3-4.24,0.9C73.03,26.44,72.43,27.32,71.98,28.62z M81.96,34.67c-1.58,0.57-3.23,1.07-4.95,1.5 c-2.34,0.62-3.82,1.24-4.44,1.84c-0.64,0.62-0.96,1.33-0.96,2.12c0,0.9,0.32,1.65,0.95,2.22c0.63,0.58,1.56,0.86,2.78,0.86 c1.28,0,2.47-0.31,3.58-0.93s1.88-1.38,2.35-2.28c0.46-0.9,0.69-2.06,0.69-3.49V34.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9068,
    y1: 8.0124,
    x2: 123.7916,
    y2: 52.8464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.84,7.47h11.51v15.27c1.56-1.62,3.12-2.78,4.66-3.48c1.55-0.7,3.37-1.05,5.48-1.05 c3.13,0,5.59,0.95,7.39,2.86c1.8,1.9,2.7,4.83,2.7,8.76v19.08h-11.56V32.41c0-1.88-0.35-3.22-1.05-4c-0.7-0.78-1.68-1.17-2.94-1.17 c-1.4,0-2.53,0.53-3.39,1.58c-0.87,1.06-1.3,2.95-1.3,5.68v14.42H98.84V7.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9411,
    y1: 5.7999,
    x2: 179.1045,
    y2: 42.4559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.04,7.47h31.67v8.91h-18.8v7.24h16.06v8.37H167.9v16.94h-12.86V7.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.1917,
    y1: 19.6316,
    x2: 215.6785,
    y2: 48.1875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.15,33.99c0-4.58,1.55-8.35,4.64-11.32c3.09-2.97,7.27-4.45,12.52-4.45c6.01,0,10.55,1.74,13.63,5.23 c2.47,2.81,3.7,6.27,3.7,10.38c0,4.62-1.53,8.4-4.59,11.35c-3.06,2.95-7.3,4.42-12.71,4.42c-4.83,0-8.73-1.22-11.7-3.68 C191.98,42.89,190.15,38.91,190.15,33.99z M201.69,33.97c0,2.68,0.54,4.66,1.63,5.94c1.08,1.28,2.45,1.92,4.09,1.92 c1.66,0,3.02-0.63,4.09-1.89c1.06-1.26,1.6-3.29,1.6-6.08c0-2.6-0.54-4.54-1.61-5.81s-2.4-1.91-3.99-1.91 c-1.68,0-3.06,0.65-4.16,1.94C202.23,29.36,201.69,31.33,201.69,33.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.5383,
    y1: 19.6316,
    x2: 253.0251,
    y2: 48.1875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.5,33.99c0-4.58,1.55-8.35,4.64-11.32c3.09-2.97,7.27-4.45,12.52-4.45c6.01,0,10.55,1.74,13.63,5.23 c2.47,2.81,3.7,6.27,3.7,10.38c0,4.62-1.53,8.4-4.59,11.35c-3.06,2.95-7.3,4.42-12.71,4.42c-4.83,0-8.73-1.22-11.7-3.68 C229.33,42.89,227.5,38.91,227.5,33.99z M239.04,33.97c0,2.68,0.54,4.66,1.63,5.94c1.08,1.28,2.45,1.92,4.09,1.92 c1.66,0,3.02-0.63,4.09-1.89c1.06-1.26,1.6-3.29,1.6-6.08c0-2.6-0.54-4.54-1.61-5.81s-2.4-1.91-3.99-1.91 c-1.68,0-3.06,0.65-4.16,1.94C239.58,29.36,239.04,31.33,239.04,33.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.7589,
    y1: 6.6094,
    x2: 294.492,
    y2: 52.9124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M266.26,7.47h11.76v21.39l8.59-9.97h14.16l-10.77,10.52l11.39,19.51h-12.97l-6.08-12.04l-4.33,4.23v7.8h-11.76 V7.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8159,
    y1: 46.9025,
    x2: 36.6246,
    y2: 76.0159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.94,52.03h12.48l4.82,11.48l4.78-11.48H45.5v18.87h-7.78V56.5l-5.99,14.39H24.7L18.72,56.5v14.39h-7.77 V52.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.3176,
    y1: 55.8896,
    x2: 67.391,
    y2: 75.0693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.82,61.65l-8.15-0.53c0.31-0.88,0.75-1.56,1.33-2.07c0.58-0.5,1.41-0.94,2.5-1.31 c0.78-0.27,1.86-0.47,3.23-0.62c1.37-0.15,2.85-0.22,4.44-0.22c2.56,0,4.61,0.09,6.16,0.26c1.55,0.18,2.84,0.54,3.88,1.1 c0.73,0.39,1.3,0.93,1.72,1.64s0.63,1.38,0.63,2.03v6.04c0,0.64,0.07,1.15,0.2,1.51c0.13,0.36,0.42,0.83,0.87,1.4h-8.01 c-0.32-0.35-0.53-0.62-0.63-0.8c-0.1-0.18-0.2-0.47-0.29-0.87c-1.12,0.66-2.23,1.13-3.33,1.42c-1.51,0.38-3.26,0.57-5.26,0.57 c-2.65,0-4.67-0.38-6.05-1.13C49.68,69.31,49,68.38,49,67.28c0-1.04,0.5-1.89,1.49-2.56c0.99-0.67,2.82-1.17,5.49-1.49 c3.2-0.39,5.27-0.67,6.22-0.83c0.95-0.16,1.96-0.37,3.02-0.62c0-0.64-0.22-1.09-0.65-1.35c-0.43-0.26-1.19-0.39-2.28-0.39 c-1.4,0-2.45,0.14-3.14,0.41C58.59,60.66,58.15,61.06,57.82,61.65z M65.22,64.41c-1.17,0.26-2.4,0.48-3.67,0.68 c-1.73,0.28-2.83,0.56-3.29,0.84c-0.48,0.28-0.71,0.6-0.71,0.97c0,0.41,0.23,0.75,0.7,1.01c0.47,0.26,1.15,0.39,2.06,0.39 c0.95,0,1.83-0.14,2.65-0.42c0.82-0.28,1.4-0.63,1.74-1.04c0.34-0.41,0.51-0.94,0.51-1.59V64.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.8379,
    y1: 54.2738,
    x2: 94.6392,
    y2: 74.7144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M77.73,57.23h7.94v2.23c1.19-0.91,2.39-1.56,3.6-1.95c1.22-0.39,2.7-0.59,4.44-0.59 c2.36,0,4.21,0.43,5.54,1.29c1.33,0.86,2,2.19,2,4v8.69h-8.57v-7.52c0-0.86-0.26-1.46-0.78-1.82c-0.52-0.36-1.24-0.53-2.18-0.53 c-1.03,0-1.87,0.24-2.51,0.72c-0.64,0.48-0.96,1.34-0.96,2.59v6.56h-8.53V57.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.6808,
    y1: 55.8896,
    x2: 122.7542,
    y2: 75.0693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.18,61.65l-8.15-0.53c0.31-0.88,0.75-1.56,1.33-2.07c0.58-0.5,1.41-0.94,2.5-1.31 c0.78-0.27,1.86-0.47,3.23-0.62c1.37-0.15,2.85-0.22,4.44-0.22c2.56,0,4.61,0.09,6.16,0.26c1.55,0.18,2.84,0.54,3.88,1.1 c0.73,0.39,1.3,0.93,1.72,1.64c0.42,0.71,0.63,1.38,0.63,2.03v6.04c0,0.64,0.07,1.15,0.2,1.51c0.13,0.36,0.42,0.83,0.87,1.4h-8.01 c-0.32-0.35-0.53-0.62-0.63-0.8c-0.1-0.18-0.2-0.47-0.29-0.87c-1.12,0.66-2.23,1.13-3.33,1.42c-1.51,0.38-3.26,0.57-5.26,0.57 c-2.65,0-4.67-0.38-6.05-1.13c-1.38-0.75-2.06-1.69-2.06-2.79c0-1.04,0.5-1.89,1.49-2.56c0.99-0.67,2.82-1.17,5.49-1.49 c3.2-0.39,5.27-0.67,6.22-0.83c0.95-0.16,1.96-0.37,3.02-0.62c0-0.64-0.22-1.09-0.65-1.35c-0.43-0.26-1.19-0.39-2.28-0.39 c-1.4,0-2.45,0.14-3.14,0.41C113.96,60.66,113.52,61.06,113.18,61.65z M120.58,64.41c-1.17,0.26-2.4,0.48-3.67,0.68 c-1.73,0.28-2.83,0.56-3.29,0.84c-0.48,0.28-0.71,0.6-0.71,0.97c0,0.41,0.23,0.75,0.7,1.01c0.47,0.26,1.15,0.39,2.06,0.39 c0.95,0,1.83-0.14,2.65-0.42c0.82-0.28,1.4-0.63,1.74-1.04c0.34-0.41,0.51-0.94,0.51-1.59V64.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.3188,
    y1: 55.8205,
    x2: 151.1668,
    y2: 76.3417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M148.58,57.23h7.98v12.91l0.02,0.6c0,0.86-0.3,1.68-0.89,2.45c-0.59,0.78-1.38,1.4-2.37,1.89 c-0.99,0.48-2.24,0.83-3.75,1.04c-1.52,0.21-3.25,0.32-5.21,0.32c-4.47,0-7.54-0.41-9.21-1.24c-1.67-0.82-2.5-1.93-2.5-3.31 c0-0.17,0.01-0.4,0.04-0.69l8.28,0.58c0.21,0.47,0.53,0.8,0.96,0.98c0.63,0.27,1.42,0.4,2.37,0.4c1.23,0,2.15-0.2,2.76-0.6 c0.61-0.4,0.91-1.11,0.91-2.11v-2.07c-0.84,0.61-1.68,1.05-2.51,1.33c-1.31,0.43-2.73,0.64-4.25,0.64c-2.98,0-5.38-0.8-7.21-2.39 c-1.3-1.13-1.95-2.63-1.95-4.49c0-2.13,0.84-3.75,2.51-4.86c1.68-1.12,3.87-1.67,6.58-1.67c1.73,0,3.16,0.18,4.28,0.54 c1.13,0.36,2.18,0.96,3.15,1.79V57.23z M140.55,63.85c0,0.99,0.34,1.72,1.03,2.19c0.68,0.48,1.58,0.71,2.7,0.71 c1.06,0,1.95-0.25,2.67-0.74c0.72-0.49,1.08-1.24,1.08-2.23c0-0.99-0.38-1.76-1.13-2.28c-0.75-0.53-1.68-0.79-2.77-0.79 c-1.09,0-1.96,0.24-2.61,0.73C140.87,61.92,140.55,62.73,140.55,63.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.9427,
    y1: 56.0693,
    x2: 177.3307,
    y2: 72.3298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.48,65.36h-17.1c0.15,0.84,0.52,1.47,1.11,1.88c0.82,0.59,1.9,0.89,3.23,0.89c0.84,0,1.63-0.13,2.39-0.39 c0.46-0.16,0.96-0.45,1.49-0.86l8.4,0.48c-1.29,1.37-2.84,2.36-4.65,2.95c-1.82,0.6-4.42,0.89-7.82,0.89 c-2.95,0-5.27-0.26-6.96-0.77c-1.69-0.51-3.09-1.32-4.2-2.43c-1.11-1.11-1.67-2.42-1.67-3.92c0-2.14,1.11-3.86,3.34-5.19 c2.23-1.32,5.31-1.98,9.23-1.98c3.19,0,5.7,0.3,7.54,0.89s3.25,1.45,4.21,2.57c0.96,1.12,1.45,2.59,1.45,4.39V65.36z M176.8,62.85 c-0.17-1.01-0.61-1.74-1.33-2.17c-0.72-0.44-1.67-0.66-2.84-0.66c-1.36,0-2.44,0.33-3.25,0.99c-0.52,0.41-0.85,1.03-0.98,1.84 H176.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.9549,
    y1: 51.1982,
    x2: 214.3136,
    y2: 77.8003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M188.52,57.23h7.96v1.99c1.15-0.83,2.31-1.42,3.47-1.78c1.17-0.35,2.58-0.53,4.23-0.53 c1.78,0,3.18,0.19,4.22,0.58c1.03,0.39,1.88,0.96,2.54,1.72c1.34-0.89,2.56-1.5,3.66-1.82c1.1-0.32,2.46-0.48,4.08-0.48 c2.39,0,4.25,0.44,5.59,1.31c1.34,0.87,2.01,2.23,2.01,4.09v8.58h-8.55v-7.79c0-0.62-0.2-1.08-0.58-1.38 c-0.57-0.47-1.28-0.71-2.13-0.71c-1,0-1.81,0.22-2.42,0.67c-0.61,0.45-0.92,1.16-0.92,2.15v7.05h-8.55v-7.53 c0-0.6-0.06-1.01-0.17-1.22c-0.18-0.34-0.5-0.62-0.95-0.83c-0.45-0.21-0.97-0.32-1.58-0.32c-0.98,0-1.79,0.23-2.42,0.68 c-0.63,0.45-0.95,1.2-0.95,2.24v6.98h-8.55V57.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5984,
    y1: 56.0693,
    x2: 246.9864,
    y2: 72.3298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M255.13,65.36h-17.1c0.15,0.84,0.52,1.47,1.11,1.88c0.82,0.59,1.9,0.89,3.23,0.89c0.84,0,1.63-0.13,2.39-0.39 c0.46-0.16,0.96-0.45,1.49-0.86l8.4,0.48c-1.29,1.37-2.84,2.36-4.65,2.95c-1.82,0.6-4.42,0.89-7.82,0.89 c-2.95,0-5.27-0.26-6.96-0.77c-1.69-0.51-3.09-1.32-4.2-2.43c-1.11-1.11-1.67-2.42-1.67-3.92c0-2.14,1.11-3.86,3.34-5.19 c2.23-1.32,5.31-1.98,9.23-1.98c3.19,0,5.7,0.3,7.54,0.89s3.25,1.45,4.21,2.57c0.96,1.12,1.45,2.59,1.45,4.39V65.36z M246.46,62.85 c-0.17-1.01-0.61-1.74-1.33-2.17c-0.72-0.44-1.67-0.66-2.84-0.66c-1.36,0-2.44,0.33-3.25,0.99c-0.52,0.41-0.85,1.03-0.98,1.84 H246.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.2207,
    y1: 54.2737,
    x2: 275.0222,
    y2: 74.7145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M258.11,57.23h7.94v2.23c1.19-0.91,2.39-1.56,3.6-1.95c1.22-0.39,2.7-0.59,4.44-0.59 c2.36,0,4.21,0.43,5.54,1.29c1.33,0.86,2,2.19,2,4v8.69h-8.57v-7.52c0-0.86-0.26-1.46-0.78-1.82c-0.52-0.36-1.24-0.53-2.18-0.53 c-1.03,0-1.87,0.24-2.51,0.72c-0.64,0.48-0.96,1.34-0.96,2.59v6.56h-8.53V57.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.0888,
    y1: 53.8156,
    x2: 299.433,
    y2: 71.7323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    style: {
      stopColor: "#2E7B3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    style: {
      stopColor: "#30733D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    style: {
      stopColor: "#325E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F4633"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M296.08,52.03v5.2h4.69v3.84h-4.69v4.84c0,0.58,0.09,0.97,0.27,1.16c0.28,0.29,0.77,0.44,1.47,0.44 c0.63,0,1.51-0.11,2.64-0.33l0.63,3.62c-2.11,0.28-4.08,0.42-5.91,0.42c-2.12,0-3.69-0.17-4.69-0.5c-1.01-0.33-1.75-0.84-2.23-1.52 c-0.48-0.68-0.72-1.78-0.72-3.31v-4.81h-3.14v-3.84h3.14v-2.51L296.08,52.03z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M12.42,86.01c0.11-0.68,0.13-0.91,0.13-1.98V81.7c0-0.86-0.02-1.1-0.07-1.54c1.06,0.08,1.41,0.09,2.56,0.09 h11.6c1.03,0,1.35-0.03,1.91-0.2l1.98,1.22c-0.25,0.27-0.29,0.36-0.36,0.77c-0.56,3.16-1.32,4.85-2.87,6.47 c-1.26,1.29-3.03,2.36-5.48,3.28c-0.99,0.38-1.68,0.59-3.16,1c-0.72-0.97-1.37-1.59-2.67-2.51c2.09-0.39,3.21-0.71,4.56-1.27 c3.34-1.42,4.83-3.16,5.27-6.28h-9.23v1.33c0,1.12,0,1.45,0.11,1.94H12.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M31.21,84.52c1.06,0.11,2.27,0.14,4.6,0.14h10.73c2.24,0,3.1-0.03,4.6-0.14v2.92 c-1.08-0.08-2.06-0.09-4.62-0.09H35.84c-2.51,0-3.25,0.02-4.62,0.09V84.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M70.5,81.45c-0.25,0.26-0.29,0.33-0.47,0.85c-1.01,2.81-2.36,4.7-4.51,6.43c-2.09,1.68-4.6,2.89-8.55,4.11 c-0.88-1.15-1.35-1.56-2.83-2.54c3.23-0.71,5.59-1.63,7.56-2.96c1.89-1.29,3.03-2.66,3.73-4.48h-9.31c-2.18,0-2.58,0.02-3.77,0.09 v-2.74c0.96,0.11,1.64,0.12,3.84,0.12h10.66c0.74,0,1.14-0.04,1.64-0.2L70.5,81.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M80.56,82.88c-1.86,0-2.65,0.02-3.64,0.08V80.3c1.23,0.09,1.93,0.12,3.7,0.12l12.3-0.01 c0.72,0,1.08-0.05,1.55-0.15l2.15,1.63c-0.36,0.23-0.47,0.33-1.03,0.97c-2.31,2.62-4.15,4.11-7.12,5.79 c0.96,0.77,1.59,1.32,2.67,2.3l-3.37,1.77c-1.35-1.48-2.47-2.53-4.33-3.95c-1.82-1.41-2.87-2.1-4.51-3.01l3.07-1.45 c1.84,1.01,2.58,1.48,3.88,2.4c1.28-0.71,2.69-1.68,3.5-2.39c0.56-0.47,1.17-1.12,1.44-1.47L80.56,82.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M104.11,92.91c0.11-0.59,0.16-1.1,0.16-2.13v-2.72c-1.68,0.67-3.52,1.16-6.46,1.75 c-0.61-1.06-0.96-1.51-1.84-2.33c2.38-0.33,4.71-0.83,6.73-1.44c2.29-0.68,3.79-1.36,5.66-2.53l-6.87,0.03 c-1.95,0-2.24,0.02-3.23,0.08v-2.45c1.03,0.09,1.93,0.12,3.28,0.12h2.67v-0.83c0-0.68-0.02-0.88-0.11-1.41h4.17 c-0.09,0.44-0.13,0.82-0.13,1.38v0.85h3.57c0.65,0,1.01-0.05,1.44-0.17l1.75,1.38c-0.36,0.17-0.36,0.17-1.03,0.7 c-1.14,0.86-1.39,1.03-4.13,2.62c2.85,0.68,5.01,1.39,7.27,2.37l-2.22,2.22c-1.86-0.95-3.95-1.75-6.58-2.53v2.92 c0,1.2,0,1.38,0.13,2.12H104.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M118.91,83.2c2.58,0.7,4.24,1.26,6.26,2.15l-1.91,2.37c-1.93-0.97-3.91-1.69-6.42-2.36L118.91,83.2z  M117.5,89.81c2.13-0.01,4.74-0.38,6.91-0.97c2.63-0.71,4.65-1.77,6.29-3.3c1.08-1,1.73-1.88,2.47-3.31 c1.21,0.89,2.02,1.35,3.3,1.89c-1.15,1.81-2.07,2.86-3.5,3.95c-2.27,1.74-5.05,2.93-8.66,3.69c-1.32,0.29-2.29,0.45-4.09,0.67 c-0.65,0.08-1.1,0.15-1.59,0.26L117.5,89.81z M120.59,79.5c2.65,0.65,4.56,1.24,6.44,2l-2,2.31c-2.31-1.01-4.18-1.63-6.44-2.16 L120.59,79.5z M132.78,79.59c0.74,0.71,1.19,1.29,1.64,2.1l-2.22,0.59c-0.43-0.85-0.9-1.5-1.57-2.19L132.78,79.59z M135.56,78.94 c0.74,0.7,1.19,1.27,1.64,2.07l-2.15,0.57c-0.54-0.98-0.72-1.22-1.62-2.15L135.56,78.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M154.38,80.28c-0.31,0.38-0.49,0.67-0.94,1.41c-0.92,1.5-1.82,2.72-2.99,3.99c1.95,1.12,2.65,1.57,4.89,3.17 L152.29,91c-1.23-1.09-2.51-2.03-4.24-3.1c-2.13,1.86-4.87,3.39-8.69,4.81c-0.76-0.91-1.44-1.47-2.83-2.28 c2.78-0.89,4.31-1.56,6.08-2.63c0.92-0.56,1.68-1.09,2.4-1.68c-2.78-1.42-4.02-2-5.84-2.69l2.76-1.83c2.04,0.8,3.05,1.27,5.3,2.37 c1.3-1.41,2.58-3.45,2.92-4.64L154.38,80.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M160.11,80.04c2.83,1.12,4.29,1.81,6.17,2.96l-2.65,2.36c-1.95-1.38-3.86-2.37-6.1-3.19L160.11,80.04z  M157.75,89.43c2.29-0.12,4.65-0.5,6.76-1.09c2.83-0.79,4.85-1.92,6.58-3.74c0.94-0.97,1.55-1.8,2.2-2.96 c1.1,0.89,1.62,1.2,3.3,2.03c-2.04,2.98-4.17,4.76-7.32,6.12c-2.42,1.06-4.56,1.62-8.73,2.27c-0.88,0.14-1.01,0.15-1.62,0.27 L157.75,89.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M180.97,92.64c0.09-0.68,0.13-1.12,0.13-2.31v-8.8c0-1.23-0.02-1.38-0.16-2.19h4.33 c-0.09,0.44-0.11,1.2-0.11,2.21v2.07c3.82,0.85,6.71,1.74,10.21,3.15l-2.13,2.57c-2.18-1.01-4.83-2-7.07-2.63 c-0.79-0.21-0.79-0.21-1.01-0.3v3.93c0,1.01,0.04,1.77,0.13,2.31H180.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M208.87,79.65c-0.09,0.7-0.11,0.97-0.11,2.03v3.01c0,1.07,0.02,1.56,0.11,2.16h-4.35 c0.11-0.54,0.13-1.07,0.13-2.21v-2.99c0-0.92-0.02-1.33-0.13-2H208.87z M219.31,79.65c-0.09,0.85-0.11,1.07-0.11,2.04v1.77 c0,2.07-0.18,3.52-0.52,4.4c-0.67,1.65-2.2,2.89-4.67,3.84c-1.28,0.5-2.47,0.82-4.67,1.24c-0.52-1.01-1.08-1.65-2.29-2.59 c2.15-0.27,3.3-0.51,4.44-0.92c1.98-0.71,2.99-1.6,3.34-2.93c0.13-0.56,0.25-1.89,0.25-3.21v-1.57c0-1.1-0.02-1.42-0.13-2.07 H219.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M224.46,87.9c5.54,0.41,10.08,1.07,15.44,2.25l-1.26,2.66c-2.58-0.71-4.83-1.16-8.31-1.69 c-2.72-0.39-4.62-0.6-7.32-0.82L224.46,87.9z M226.25,83.64c3.64,0.26,7.65,0.82,12.35,1.74l-1.15,2.56 c-1.97-0.51-3.68-0.85-6.51-1.25c-2-0.29-3.55-0.45-6.06-0.65L226.25,83.64z M226.57,79.42c4.96,0.35,7.43,0.67,12.95,1.6 l-1.19,2.54c-5.03-1.01-8.3-1.44-13.15-1.72L226.57,79.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M254.52,86.04c-0.18,1.77-0.61,2.77-1.62,3.9c-1.24,1.36-2.92,2.22-6.02,3.07c-0.81-1.09-1.28-1.53-2.63-2.39 c4.11-0.82,5.88-2.16,6.06-4.58h-4.6c-1.86,0-2.49,0.02-3.39,0.08v-2.54c0.96,0.11,1.59,0.12,3.46,0.12h12.5 c2,0,2.56-0.01,3.57-0.11v2.53c-1.3-0.08-1.5-0.08-3.5-0.08H254.52z M244.62,79.69c1.01,0.11,1.53,0.12,3.48,0.12h7.86 c2.09,0,2.6-0.02,3.59-0.12v2.56c-0.88-0.06-1.23-0.08-3.52-0.08h-7.99c-1.95,0-2.56,0.02-3.41,0.08V79.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M267.03,82.67c0.88,1.12,1.57,2.36,2.18,3.83l-3.5,0.71c-0.58-1.59-1.03-2.5-2-3.92L267.03,82.67z  M280.09,82.93c-0.13,0.27-0.16,0.33-0.34,0.92c-0.67,2.13-1.55,3.67-2.81,4.93c-1.21,1.21-2.81,2.24-4.71,3.07 c-0.79,0.33-1.39,0.56-2.72,1.01c-0.76-0.92-1.21-1.3-2.47-2.13c4.51-1.18,6.96-2.69,8.35-5.2c0.58-1.06,0.96-2.3,0.99-3.19 L280.09,82.93z M271.96,82.04c1.19,1.56,1.59,2.24,2.18,3.69l-3.43,0.71c-0.43-1.25-1.03-2.39-2.02-3.8L271.96,82.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M285.93,92.64c0.09-0.68,0.13-1.12,0.13-2.31v-8.8c0-1.23-0.02-1.38-0.16-2.19h4.33 c-0.09,0.44-0.11,1.2-0.11,2.21v2.07c3.82,0.85,6.71,1.74,10.21,3.15l-2.13,2.57c-2.18-1.01-4.83-2-7.07-2.63 c-0.79-0.21-0.79-0.21-1.01-0.3v3.93c0,1.01,0.04,1.77,0.13,2.31H285.93z M296.37,80.22c0.85,0.83,1.3,1.39,1.82,2.3l-2.27,0.65 c-0.47-0.88-1.06-1.66-1.8-2.4L296.37,80.22z M299.17,79.48c0.81,0.73,1.39,1.41,1.91,2.22l-2.27,0.64 c-0.45-0.76-1.1-1.59-1.82-2.3L299.17,79.48z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M300.1,3.99c0.62,0.24,1.09,0.57,1.42,1c0.33,0.43,0.49,0.94,0.49,1.52c0,0.44-0.1,0.84-0.31,1.19 c-0.2,0.35-0.48,0.65-0.82,0.89c-0.34,0.24-0.72,0.42-1.13,0.54l2.48,3.86h-2.29l-2.2-3.6h-2.54v3.6h-2.01V3.63h4.69 C298.74,3.63,299.48,3.75,300.1,3.99z M297.54,8.16c0.75,0,1.34-0.13,1.75-0.4c0.41-0.27,0.62-0.66,0.62-1.19 c0-0.53-0.21-0.94-0.62-1.23c-0.42-0.29-0.98-0.43-1.69-0.43h-2.39v3.25H297.54z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 297.18,
    cy: 8.53,
    r: 7.06
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.c2b150fff95e87b0089f49a9d9a303c6.svg";
export { ForwardRef as ReactComponent };